import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import Checkbox from "../../../common/Checkbox";
import Swal from "sweetalert2";

function WorkplaceUpdateModal({ title, id, onClose, handleView, originRows, MenuUpdateYN }) {
  const appStore = useContext(AppContext);
  const workplaceNameRef = useRef(null);
  const [inputs, setInputs] = useState({
    workplace_id:0,
    workplace_name:'',
    headoffice_yn:'',
    check_yn:false,
    workplace_address_post:'',
    workplace_address:'',
    workplace_address_addition:'',
  });
  const [updateFlag, setUpdateFlag] = useState(MenuUpdateYN === 'Y' && originRows.some(row =>
    [row.reg_user_id, row.update_user_id].includes(Number(localStorage.getItem('user_id')))
  ));

  useEffect(() => {
      // Mount 될때만 실행된다.
  }, [])

  useEffect(() => {
      //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    handleInitSelect();
  }, [originRows]);

  const onCheckBoxChange = (ynName, type, value) => {
    let yn = ''
    if(value) {
      yn = 'Y'
    } else {  yn = 'N'}

    const nextInputs = {
        ...inputs,
        [type] : value,
        [ynName] : yn,
    };
    setInputs(nextInputs);
  };
  
  const onSelectChange = (type, value) => {
    const nextInputs = {
        ...inputs,
        [type] : value
    };
    setInputs(nextInputs);
  };

  const onChange = (e)=>{
    const {name, value} = e.target;
    const nextInputs = {
        ...inputs,
        [name]: value, 
    };
    setInputs(nextInputs);
  };

  const handleInitSelect = () => {
    
    //조회
    setInputs({
      workplace_id: originRows[0].workplace_id,
      workplace_name: originRows[0].workplace_name,
      headoffice_yn: originRows[0].headoffice_yn,
      check_yn: originRows[0].headoffice_yn === 'Y'? true:false,
      workplace_address_post: originRows[0].workplace_address_post,
      workplace_address: originRows[0].workplace_address,
      workplace_address_addition: originRows[0].workplace_address_addition,
      reg_user_id: originRows[0].reg_user_id,
      reg_user_name: originRows[0].reg_user_name,
      reg_datetime: originRows[0].reg_datetime,
      update_user_id: originRows[0].update_user_id,
      update_user_name: originRows[0].update_user_name,
      update_datetime: originRows[0].update_datetime,
    });

  }

  const handleSave = (event) => {
    // 이름 확인 정규식(2-20 자리 영문소+영문대+한글+띄어쓰기 입력 가능) : !(/^[가-힣a-zA-z\s]{2,20}$/).test(inputs.user_name.trim())
    // ID 확인 정규식(4-20 자리 영문소+영문대+숫자 입력 가능) : !(/^[a-zA-z0-9]{4,20}$/).test(inputs.user_login_id.trim())
    // 날짜 확인 정규식(19@@년도 입력 불가) : !(/^2[0-1]\d{2}-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/).test(inputs.user_start_date.trim())
    // 날짜 확인 정규식(19@@년도 입력 가능) : !(/^(19\d{2}|2[0-1]\d{2})-(0[0-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/).test(inputs.user_start_date.trim())
    // 휴대폰 정규식(010-숫자4자리-숫자4자리 입력 가능) : !(/^010-\d{4}-\d{4}$/).test(inputs.user_phone.trim())
    // 전화번호 정규식(숫자3자리-숫자4자리-숫자4자리) : !(/^\d{3}-(\d{3,4})-\d{4}$/).test(inputs.user_call.trim())
    // E-Mail 정규식 : !(/^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/).test(inputs.user_email.trim())
    // 계좌번호 정규식(숫자, 하이픈 5-30자리 이하) : !(/^[0-9-]{5,30}$/).test(inputs.bank_number.trim())
    
    let msg = '';
    if(inputs.workplace_name.trim() === ''){
      msg = '사업장명은 필수로 입력 해주세요.';
    }else if(!(/^[가-힣a-zA-z0-9\s]{2,20}$/).test(inputs.workplace_name.trim())){
      msg = '사업장명의 입력이 올바르지 않습니다.<br/>(입력 양식 : 한글+영문+숫자+띄어쓰기 2~20자리)';
    }else if(inputs.workplace_address_post.trim() !== '' && !(/^[0-9]{5}$/).test(inputs.workplace_address_post.trim())){
      msg = '우편번호 입력이 올바르지 않습니다.<br/>(입력 양식 : 숫자 5자리)';
    }else{
      if (appStore.loading) return;
      appStore.setLoading(true);
      
      axios.post("/api/p/Workplace/Update", new URLSearchParams({
        workplace_id:inputs.workplace_id,
        workplace_name:inputs.workplace_name.trim(),
        headoffice_yn:inputs.headoffice_yn.trim(),
        workplace_address_post:inputs.workplace_address_post.trim(),
        workplace_address:inputs.workplace_address.trim(),
        workplace_address_addition:inputs.workplace_address_addition.trim(),
     }),
     { withCredentials: true })
     .then(function (response) {
        if(response.status === 200){
          Swal.fire({
            title: '사업장 수정 완료',
            text: '정상적으로 사업장이 수정 되었습니다.',
            confirmButtonText: '확인',
            timer:5000,
            timerProgressBar: true
          }).then((result) => {
            handleInitSelect();
            handleView();
          });
         }else{
          appStore.capture();
         }
     })
      .catch(function (error) {
        appStore.capture();
      })
      .finally(() => {
        appStore.setLoading(false); 
      });
    }

    if(msg !== ''){
      Swal.fire({
        title: '<p style="color:red">사업장 수정 오류</p>',
        html: msg,
        confirmButtonText: '확인'
      });
    }
  };

  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{height: '350px'}}>
          <div>
            <table className="ModalTABLE">
              <tbody>
              <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">사업장명<span className="essential">*</span></div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="사업장명" value={inputs.workplace_name} name="workplace_name" onChange={(e) => onChange(e) } ref={workplaceNameRef} autoComplete="off" />
                      </div>
                    </div>
                  </td>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title" style={{height: '43px'}}>본사여부</div>
                      <div className="modal_filed_input" style={{marginTop:'4px'}}>
                        <Checkbox checked={inputs.check_yn} onChange={(e) => onCheckBoxChange('headoffice_yn','check_yn',e)}>
                        </Checkbox>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD">
                    <div className="modal_filed">
                      <div className="modal_filed_title">우편번호</div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="우편번호" value={inputs.workplace_address_post} name="workplace_address_post" onChange={(e) => onChange(e) } autoComplete="off" />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_filed">
                      <div className="modal_filed_title">주소</div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="주소" value={inputs.workplace_address} name="workplace_address" onChange={(e) => onChange(e) } autoComplete="off" style={{width: '755px'}} />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_filed">
                      <div className="modal_filed_title">상세주소</div>
                      <div className="modal_filed_input">
                        <input type="text" placeholder="상세주소" value={inputs.workplace_address_addition} name="workplace_address_addition" onChange={(e) => onChange(e) } autoComplete="off" style={{width: '755px'}} />
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="ModalTD" colSpan={2}>
                    <div className="modal_action">
                      <div className="modal_button">
                        <Button 
                          onClick={()=> { onClose?.(); }}
                          className="btn-p"
                          sx={{  
                              m: 1, 
                              fontSize: 15, 
                              color: "white", 
                              borderColor: "#808080", 
                              backgroundColor: "#808080",
                              ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                          }} 
                          variant="outlined">
                          닫기
                        </Button>
                      </div>
                      {updateFlag &&
                      <div className="modal_button">
                        <Button 
                          onClick={handleSave}
                          className="btn-p btn-u"
                          sx={{  
                              m: 1, 
                              fontSize: 18, 
                              color: "white", 
                              borderColor: "#FF3636", 
                              backgroundColor: "#FF3636",
                              ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                          }} 
                          variant="outlined">
                          수정
                        </Button> 
                      </div>
                      }
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </PCModal>
  );
}

export default WorkplaceUpdateModal;